/**
 * Converts a Map to a dictionary object
 */
export function mapToObject<V>(map: Map<string, V>): { [key: string]: V } {
  const obj: { [key: string]: V } = {};
  map.forEach((v: V, k: string) => (obj[k] = v));
  return obj;
}

/**
 * Converts a dictionary object to a Map
 */
export function objectToMap<V>(obj: { [key: string]: V }): Map<string, V> {
  const map = new Map<string, V>();
  for (const key in obj) {
    map.set(key, obj[key]);
  }
  return map;
}
